import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../../pipes/pipes.module";
import { MaterialModule } from "../../../components/material/material.module";
import { CrearTipoProductoComponent } from "./crear-tipo-producto/crear-tipo-producto.component";
import { CrearTipoProductoDialog } from "./crear-tipo-producto/crear-tipo-producto-dialog/crear-tipo-producto-dialog.component";
import { EditarTipoProductoComponent } from "./editar-tipo-producto/editar-tipo-producto.component";
import { EditarTipoProductoDialog } from "./editar-tipo-producto/editar-tipo-producto-dialog/editar-tipo-producto-dialog.component";
import { EliminarTipoProductoComponent } from "./eliminar-tipo-producto/eliminar-tipo-producto.component";
import { EliminarTipoProductoDialog } from "./eliminar-tipo-producto/eliminar-tipo-producto-dialog/eliminar-tipo-producto-dialog.component";
import { IrTipoProductoComponent } from "./ir-tipo-producto/ir-tipo-producto.component";
import { TipoProductoComponent } from "./tipo-producto/tipo-producto.component";
import { VerTiposProductoComponent } from "./ver-tipos-producto/ver-tipos-producto.component";
import { TipoProductoService } from "../../../providers/tipo-producto.service";
import { RouterModule } from "@angular/router";
import { ArchivoTipoProductoModule } from "./archivos-tipo-producto/archivo-tipo-producto.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        RouterModule,
        ArchivoTipoProductoModule,
    ],
    declarations: [
        CrearTipoProductoComponent,
        CrearTipoProductoDialog,
        EditarTipoProductoComponent,
        EditarTipoProductoDialog,
        EliminarTipoProductoComponent,
        EliminarTipoProductoDialog,
        IrTipoProductoComponent,
        TipoProductoComponent,
        VerTiposProductoComponent,
    ],
    providers: [
        TipoProductoService
    ],
    entryComponents: [
        CrearTipoProductoDialog,
        EditarTipoProductoDialog,
        EliminarTipoProductoDialog,
    ],
    exports: [
        CrearTipoProductoComponent,
        EditarTipoProductoComponent,
        EliminarTipoProductoComponent,
        IrTipoProductoComponent,
        TipoProductoComponent,
        VerTiposProductoComponent,
    ]
})
export class TipoProductoModule { }